import { render, staticRenderFns } from "./lgadata.vue?vue&type=template&id=7ddc9f6a&"
import script from "./lgadata.vue?vue&type=script&lang=js&"
export * from "./lgadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports